import * as React from "react";
import {Offer} from "../../shared/models/Offer";
import OfferSelectOption from "../components/OfferSelectOption";


export function offerRenderer(offer: Offer): JSX.Element {
    return <OfferSelectOption offer={offer}/>;
}
